<template>
  <div class="">
    <div class="">
      <!-- <img alt="Vue logo" class="w-100" src="../assets/hotel/t.jpg" />     -->
      <!-- <img alt="Vue logo" class="w-full" :src="img.pathLong" />     -->
      <!-- <img alt="Vue logo" class="w-full" :src="require(img)" />     -->
      <!-- <img alt="Vue logo" class="w-full" :src="require(building.face)" />     -->
      <!-- <img alt="Vue logo" class="w-full" :src="building.face" />     -->
        <!-- :src="require(`../assets/${building.face}`)" -->
      <img
        alt="Vue logo"
        class="w-full cursor-pointer"
        :src="building.face"
        @click="show()"
      />
    </div>
    <div class="" v-show="showModal">
      <!-- <ViewProjectModal @close="showModal = false" :i="i" :building="building"></ViewProjectModal> -->
      <ViewProjectModal @close="showModal = false" :building="building"></ViewProjectModal>
    </div>
  </div>
</template>

<script>
import ViewProjectModal from "./ViewProjectModal";
export default {
  components: { ViewProjectModal },
  name: "HelloWorld",
  data() {
    return {
      showModal: false,
    }
  },
  // props: ['img']
  props: {
    // i: Number,
    msg: String,
    // img: String
    building: Object,
    // img: Object
  },
  methods: {
    show() {
      this.showModal = true;
    }
  },
  created() {
    console.log(this.building);
    // this.showModal = (this.i === 0) ? true : false;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
